
import { useNavigate } from "react-router-dom";
import axios from "../api/axiosInstance";
import React, { useState, useEffect } from "react";
import Swal from "sweetalert2";
export default function SignupPage() {
  const navigate = useNavigate();

  const [form, setForm] = useState({
    name: "",
    phone: "",
    password: "",
    confirmPassword: "",
  });

  const [otp, setOtp] = useState("");
  const [step, setStep] = useState(1);
 const [message, setMessage] = useState("");
const [error, setError] = useState("");
const [sendingOtp, setSendingOtp] = useState(false);
const [verifyingOtp, setVerifyingOtp] = useState(false);
const [resendingOtp, setResendingOtp] = useState(false);
const [timer, setTimer] = useState(0);
  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSendOtp = async () => {
    if (!form.name || !form.phone || !form.password) {
      setError("All fields are required");
      return;
    }

    if (form.password !== form.confirmPassword) {
      setError("Passwords do not match");
      return;
    }

    setSendingOtp(true);
    try {
      await axios.post("/signup/send-otp/", {
        phone: form.phone,
      });

      setStep(2);
setTimer(30); 
    } catch (err) {
      setError(err.response?.data?.error || "OTP sending failed");
    } finally {
      setSendingOtp(false);
    }
  };



useEffect(() => {
  if (message || error) {
    const timer = setTimeout(() => {
      setMessage("");
      setError("");
    }, 3000);

    return () => clearTimeout(timer);
  }
}, [message, error]);

const handleResendOtp = async () => {
  setResendingOtp(true);
  try {
    await axios.post("/resend-otp/", {
      phone: form.phone,
    });

    setMessage("OTP resent successfully");
setError("");
    setTimer(30); // match backend

  } catch (err) {
    setError(err.response?.data?.error || "Resend failed");
  } finally {
    setResendingOtp(false);
  }
};


useEffect(() => {
  if (timer === 0) return;

  const interval = setInterval(() => {
    setTimer((prev) => (prev > 0 ? prev - 1 : 0));
  }, 1000);

  return () => clearInterval(interval);
}, [timer]);

  const handleVerifyOtp = async () => {
    if (!otp) {
      setError("Enter OTP");
      return;
    }

    setVerifyingOtp(true);
    try {
      await axios.post("/signup-verify-otp/", {
        phone: form.phone,
        otp,
      });

      await axios.post("register/", {
        name: form.name,
        phone: form.phone,
        password: form.password,
      });

      setError("");

Swal.fire({
  icon: "success",
  title: "Account Created",
  text: "Your account has been created successfully",
  confirmButtonColor: "#2563eb",
});

setTimeout(() => {
  navigate("/login");
}, 1500);
    } catch (err) {
      setError(err.response?.data?.error || "OTP verification failed");
    } finally {
      setVerifyingOtp(false);
    }
  };

  return (
    <div style={styles.page}>
      <div style={styles.card}>
        <h2 style={styles.title}>Create Account</h2>

        {step === 1 && (
          <>
            <input
              style={styles.input}
              name="name"
              placeholder="Full Name"
              onChange={handleChange}
onFocus={(e)=>{
  e.target.style.border="1px solid #2a7ae4";
  e.target.style.boxShadow="0 0 8px rgba(42,122,228,0.5)";
}}
onBlur={(e)=>{
  e.target.style.border="1px solid #333";
  e.target.style.boxShadow="none";
}}
            />

<div style={styles.phoneContainer}>

  <span style={styles.phonePrefix}>
    +91
  </span>

  <input
    style={styles.phoneInputNew}
    name="phone"
    placeholder="Enter phone number"

    onChange={(e)=>{

      const value = e.target.value
        .replace(/\D/g, "")
        .slice(0,10);

      handleChange({
        target:{
          name:"phone",
          value:value
        }
      });

    }}

    onFocus={(e)=>{
      e.target.style.border="1px solid #2a7ae4";
      e.target.style.boxShadow="0 0 8px rgba(42,122,228,0.5)";
    }}

    onBlur={(e)=>{
      e.target.style.border="1px solid #333";
      e.target.style.boxShadow="none";
    }}
  />

</div>

            <input
              style={styles.input}
              type="password"
              name="password"
              placeholder="Password"
              onChange={handleChange}
onFocus={(e)=>{
  e.target.style.border="1px solid #2a7ae4";
  e.target.style.boxShadow="0 0 8px rgba(42,122,228,0.5)";
}}
onBlur={(e)=>{
  e.target.style.border="1px solid #333";
  e.target.style.boxShadow="none";
}}
            />

            <input
              style={styles.input}
              type="password"
              name="confirmPassword"
              placeholder="Confirm Password"
              onChange={handleChange}
onFocus={(e)=>{
  e.target.style.border="1px solid #2a7ae4";
  e.target.style.boxShadow="0 0 8px rgba(42,122,228,0.5)";
}}
onBlur={(e)=>{
  e.target.style.border="1px solid #333";
  e.target.style.boxShadow="none";
}}
            />

            <button
              style={styles.primaryBtn}
              onClick={handleSendOtp}
              disabled={sendingOtp}
      >
{sendingOtp ? "Sending OTP..." : "Send OTP"}
            </button>
          </>
        )}

        {step === 2 && (
          <>
            <input
              style={styles.input}
              placeholder="Enter OTP"
              value={otp}
              onChange={(e) => setOtp(e.target.value)}
onFocus={(e)=>{
  e.target.style.border="1px solid #2a7ae4";
  e.target.style.boxShadow="0 0 8px rgba(42,122,228,0.5)";
}}
onBlur={(e)=>{
  e.target.style.border="1px solid #333";
  e.target.style.boxShadow="none";
}}
            />


{timer > 0 ? (
  <p style={{ color: "#aaa", fontSize: "13px" }}>
    Resend OTP in {timer}s
  </p>
) : (
  <p
    style={{ color: "#2a7ae4", cursor: "pointer", fontSize: "13px" }}
    onClick={!resendingOtp ? handleResendOtp : null}
  >
    {resendingOtp ? "Resending..." : "Resend OTP"}
  </p>
)}

{error && (
  <p style={{ color: "#f87171", fontSize: "13px", marginTop: "5px" }}>
    {error}
  </p>
)}

{message && (
  <p style={{ color: "#4ade80", fontSize: "13px", marginTop: "5px" }}>
    {message}
  </p>
)}
            <button
              style={styles.primaryBtn}
              onClick={handleVerifyOtp}
              disabled={verifyingOtp}
            >
              {verifyingOtp ? "Verifying..." : "Verify & Create Account"}
            </button>
          </>
        )}

        <p style={styles.link} onClick={() => navigate("/login")}>
          Back to Login
        </p>
      </div>
    </div>
  );
}

/* ---------------- STYLES ---------------- */

const styles = {
  page: {
    minHeight: "100vh",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    background: "#0b0f1a",
  },

  card: {
    width: "360px",
    padding: "30px",
    borderRadius: "16px",
    background: "rgba(255,255,255,0.05)",
    backdropFilter: "blur(15px)",
    boxShadow: "0 10px 40px rgba(0,0,0,0.6)",
    textAlign: "center",
  },

  title: {
    color: "#fff",
    marginBottom: "20px",
  },

  input: {
    width: "90%",
    padding: "12px",
    marginBottom: "14px",
    borderRadius: "20px",
    border: "1px solid #333",
background:"#0f172a",
  color:"#fff",
    fontSize: "14px",
    outline: "none",
  },

  primaryBtn: {
    width: "90%",
    padding: "12px",
    background: "linear-gradient(135deg, #2a7ae4, #1d4ed8)",
    color: "#fff",
    border: "none",
    borderRadius: "10px",
    fontSize: "15px",
    cursor: "pointer",
    marginTop: "10px",
    transition: "0.3s",
  },
phoneContainer:{
  position:"relative",
  marginBottom:"10px",
  width:"100%",
},

phonePrefix:{
  position:"absolute",
  left:"12px",
  top:"50%",
  transform:"translateY(-50%)",
  color:"#aaa",
  fontSize:14,
  zIndex:1,
},

phoneInputNew:{
  width:"97%",
  padding:"12px 12px 12px 45px",
  borderRadius:"20px",
  border:"1px solid #333",
  background:"#0f172a",
  color:"#fff",
  outline:"none",
  transition:"0.3s",
  boxSizing:"border-box",
},
  link: {
    marginTop: "15px",
    fontSize: "14px",
    color: "#2a7ae4",

    cursor: "pointer",
  },
};